/* =================== BOTÃO FLUTUANTE =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const floatBtn = document.getElementById("botao-flutuante");
    const mainBtn = document.getElementById("btn-flutuante-principal");

    if (floatBtn && mainBtn) {
      // Abre/fecha ao clicar no botão principal
      mainBtn.addEventListener("click", function (event) {
        event.stopPropagation();
        floatBtn.classList.toggle("expanded");
      });

      // Fecha ao clicar fora do botão flutuante
      document.addEventListener("click", function (event) {
        if (!floatBtn.contains(event.target)) {
          floatBtn.classList.remove("expanded");
        }
      });
    }
  });
})();
